import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { iifFreeOrCustomLicenseValid } from '@core/helpers/license/license.helper';
import { LicenseService } from '@core/services/license/license.service';
import { map } from 'rxjs';

export const accountInactiveGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	const licenseService = inject(LicenseService);

	return licenseService.license$.pipe(
		map((license) => {
			if (authService.user?.is_active && iifFreeOrCustomLicenseValid(license, true)) {
				authService.navigateAfterLogin();
				return false;
			}
			return true;
		})
	);
};
